import ApiService from '../../../../shared/services/api-service';
import commonActionCreators from '../../../../shared/store/common/action-creators';
import myDepartmentCommitTypes from '../commit-types';
import notificationsActionsCreator from '../../notifications/action-creators';

const apiActionCreators = {
  fetchMyDepartment() {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchMyDepartment'));
      const data = await ApiService.get('/api/v1/my-department')
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('fetchMyDepartment'));
      if (data.error) {
        dispatch(commonActionCreators.handleApiError(data.error));
      } else {
        dispatch(this.setMyDepartment(data));
      }
    };
  },
  loadMyDepartment() {
    return (dispatch) => {
      dispatch(this.fetchMyDepartment());
    };
  },
  replaceMyDepartment(department) {
    return {
      department,
      type: myDepartmentCommitTypes.REPLACE_MY_DEPARTMENT,
    };
  },
  setIsLoading(isLoading) {
    return {
      isLoading,
      type: myDepartmentCommitTypes.SET_MY_DEPARTMENT_IS_LOADING,
    };
  },
  setMyDepartment(departmentResponse) {
    return {
      department: departmentResponse.data,
      type: myDepartmentCommitTypes.SET_MY_DEPARTMENT,
    };
  },
  updateMyDepartment(formData) {
    const patchData = {
      data: formData,
      patched: 'details',
    };
    return async (dispatch) => {
      dispatch(this.setIsLoading('updateMyDepartment'));
      const data = await ApiService.patch('/api/v1/my-department', patchData)
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('updateMyDepartment'));
      if (data.error) {
        dispatch(commonActionCreators.handleApiError(data.error));
      } else {
        dispatch(this.updateMyDepartmentSuccess(data));
      }
    };
  },
  updateMyDepartmentSuccess(updated) {
    return (dispatch) => {
      dispatch(this.replaceMyDepartment(updated.data));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Department updated'))
    };
  },
};

export default apiActionCreators;
